
export enum SuperBillStatusEnum {
    OPEN = "Open",
    BALANCED = "Balanced"
}
